import { Language, LANGUAGES, Region, REGIONS } from '@boltenergy-be/shared'

export const GO_INFO_URLS: { [key in Region]: string | { [key in Language]: string } } = {
  [REGIONS.flanders]:
    'https://www.vlaamsenutsregulator.be/elektriciteit-en-aardgas/steuncertificaten-en-garanties-van-oorsprong/garanties-van-oorsprong-wat-het-en-hoe-werkt-het',
  [REGIONS.brussels]: {
    [LANGUAGES.NL]: 'https://brugel.brussels/nl_BE/themes/hernieuwbare-energie-11/levering-van-groene-energie-42',
    [LANGUAGES.FR]: 'https://brugel.brussels/fr/themes/infos-pour-le-secteur-de-l-energie-13/gerer-un-compte-cv-go-54'
  },
  [REGIONS.wallonia]:
    "https://energie.wallonie.be/fr/marche-des-garanties-d-origine.html?IDC=9824#:~:text=La%20garantie%20d'origine%20(GO,la%20cog%C3%A9n%C3%A9ration%20%C3%A0%20haut%2Drendement."
}
